import React, {useEffect, useRef, useState} from 'react';


import Tools from 'components/Builder/Tools';
import ToolsSetting from 'components/Builder/ToolsSetting';

import Html from 'helpers/Html';
import Workspace from 'components/Builder/canvas/Workspace';
import ModalContact from 'components/modal/ModalContact';

import useSetting from 'hooks/useSetting';
import useGroup from 'hooks/useGroup';
import useSession from 'hooks/useSession';


function Builder(props) {
	const render = useRef(null);
	const rectMinimap = useRef(null);
	const wrapper = useRef(null);
	const canvasMap = useRef(null);

	const [currentZoom, setCurrentZoom] = useState(1);
	let [active, setActive] = useState(0);
	let [disabled, setDisabled] = useState(false);
	let [reducedMap, setReducedMap] = useState(false);
	let [openContact, setOpenContact] = useState(false);


	const {
		setFetchingGroup
	} = props;

	const {
		planner
	} = useSession();


	const {
		moveGroup
	} = useGroup();

	const {
		changeTools,
		TOOLS_KEY,
		changeMode,
		MODE_KEY,
		tools,
		mode,
		resetMode
	} = useSetting();

	useEffect(() => {
		if (tools === false && mode === MODE_KEY.select) {
			setActive(3);
		}
	}, [tools, mode]);


	useEffect(() => {
		if (active !== false && moveGroup === false) {
			setActive(false);
			setDisabled(false);
		}

		if (moveGroup === true) {
			setActive(5);
			setDisabled(true);
		}
	}, [moveGroup]);

	useEffect(() => {
		updateMiniMap();
	}, [render, rectMinimap, currentZoom]);


	const onScroll = (e) => {
		updateMiniMap();
	}

	const updateMiniMap = () => {

		if (rectMinimap.current) {
			rectMinimap.current.style.borderRightStyle = 'solid';
			rectMinimap.current.style.borderBottomStyle = 'solid';
			let widthRect = parseInt(Html.getElementSize(wrapper.current, 'width') / currentZoom, 10);
			if (widthRect > planner.width) {
				widthRect = planner.width;
				rectMinimap.current.style.borderRightStyle = 'none';
			}
			let heightRect = parseInt(Html.getElementSize(wrapper.current, 'height') / currentZoom, 10);
			if (heightRect > planner.height) {
				heightRect = planner.height;
				rectMinimap.current.style.borderBottomStyle = 'none';
			}
			rectMinimap.current.style.width = widthRect + 'px';
			rectMinimap.current.style.height = heightRect + 'px';

			let scrollLeft = wrapper.current.scrollLeft;
			let scrollTop = wrapper.current.scrollTop;

			if (scrollTop !== false) {
				if (scrollTop < 0) {
					scrollTop = 0;
				}
				rectMinimap.current.style.top = (scrollTop / currentZoom) + 'px';
			}

			if (scrollLeft !== false) {
				if (scrollLeft < 0) {
					scrollLeft = 0;
				}
				rectMinimap.current.style.left = (scrollLeft / currentZoom) + 'px';
			}
		}
	}

	useEffect(() => {
		Html.addClass(document.body, 'body-builder');
		return () => {
			Html.removeClass(document.body, 'body-builder');
		}
	}, []);

	useEffect(() => {
		if (active === 0) {
			changeTools(TOOLS_KEY.paint);
		}
		if (active === 1) {
			changeTools(TOOLS_KEY.rubber);
		}
		if (active === 2) {
			changeTools(TOOLS_KEY.rule);
		}
		if (active === 3) {
			changeMode(MODE_KEY.select);
			changeTools(false);
		}
		if (active === 4) {
			resetMode();
			changeTools(false);
		}
	}, [active]);

	let sizeMiniMap = {
		width: 202,
		height: 202
	};
	sizeMiniMap.height = (sizeMiniMap.width * planner.height) / planner.width;

	let ratio = (sizeMiniMap.width * 100 / planner.width) / 100;

	sizeMiniMap.width += 2;
	sizeMiniMap.height += 2;

	return (
		<div className="Builder" id="wrapper-builder" ref={wrapper} onScroll={onScroll}>
			<ModalContact forceOpen={openContact} setForceOpenOpen={setOpenContact}/>
			<Tools
				active={active}
				setActive={setActive}
				disabled={disabled}
				setDisabled={setDisabled}
				zoom={{
					currentZoom,
					setCurrentZoom
				}}
				setFetchingGroup={setFetchingGroup}
				wrapper={wrapper}
			/>
			<ToolsSetting
				active={active}
				setActive={setActive}
				disabled={disabled}
				setDisabled={setDisabled}
				zoom={{
					currentZoom,
					setCurrentZoom
				}}
				setFetchingGroup={setFetchingGroup}
				wrapper={wrapper}
				reducedMap={reducedMap}
				setReducedMap={setReducedMap}
			/>

			<div className={'minimap' + (reducedMap ? ' reduce' : '')} style={sizeMiniMap}>
				{reducedMap === false && (
					<svg
						onClick={() => {
							setReducedMap(true);
						}}
						viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
						strokeLinecap="round" strokeLinejoin="round" className="minimise-map">
						<polyline points="4 14 10 14 10 20"></polyline>
						<polyline points="20 10 14 10 14 4"></polyline>
						<line x1="14" y1="10" x2="21" y2="3"></line>
						<line x1="3" y1="21" x2="10" y2="14"></line>
					</svg>
				)}
				<canvas
					ref={canvasMap}
					style={{
						transform: 'scale(' + ratio + ')'
					}}
				/>
				<div className="wrapper-rect-minimap" style={{
					width: planner.width,
					height: planner.height,
					transform: 'scale(' + ratio + ')'
				}}>
					<div className="rect-minimap" ref={rectMinimap}></div>
				</div>
			</div>

			<div
				className="parent-canvas"
				style={{
					width: planner.width * currentZoom,
					height: planner.height * currentZoom
				}}
			>
				<Workspace
					wrapper={wrapper}
					currentZoom={currentZoom}
					setFetchingGroup={setFetchingGroup}
					canvasMap={canvasMap}
				/>
			</div>

			<a
				href="https://www.youtube.com/channel/UCns0cZsY7yPl65qNRof5veQ"
				className="help-link"
				target="_blank"
			>
				<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
				     strokeLinecap="round" strokeLinejoin="round">
					<circle cx="12" cy="12" r="10"></circle>
					<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
					<line x1="12" y1="17" x2="12.01" y2="17"></line>
				</svg>
			</a>

			<div
				className="tracking-form"
				onClick={() => {
					setOpenContact(true);
				}}
			>
				<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
				     strokeLinecap="round" strokeLinejoin="round">
					<circle cx="12" cy="12" r="10"></circle>
					<circle cx="12" cy="12" r="4"></circle>
					<line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line>
					<line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line>
					<line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line>
					<line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line>
					<line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>
				</svg>
			</div>
		</div>
	);
}

export default Builder;
